// Angular imports
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// 3rd party imports
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { classToPlain, plainToClass } from 'class-transformer';

// Constant imports
import { URLConstants } from '../../_constants/url-constants';

// Model imports
import { WorkQueueActionParametersDto } from '../_models/work-queue-action-parameters-dto';
import { CorpAPWorkQueueEmailActionParameterDto } from '../_models/corp-ap-work-queue-email-action-parameter-dto';
import { CorpAPWorkQueueEmailActionDenyParameterDto } from '../_models/corp-ap-work-queue-email-action-deny-parameter-dto';
import { CorpAPWorkQueueDetailResultDto } from '../_models/corp-ap-work-queue-detail-result-dto';

@Injectable({
    providedIn: 'root'
})
export class WorkQueueActionsService {
    private readonly _subjectLoading = new Subject<boolean>();

    constructor(private readonly httpClient: HttpClient) {}

    onLoadingEvent(): Subject<boolean> {
        return this._subjectLoading;
    }
    showLoading(): void {
        this._subjectLoading.next(true);
    }
    hideLoading(): void {
        this._subjectLoading.next(false);
    }

    getWorkQueueActionsDetail(baseParams: WorkQueueActionParametersDto): Observable<CorpAPWorkQueueDetailResultDto> {
        const url = `${URLConstants.ccWorkQueueEmailActionsUrl}/detail${baseParams.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((plain: any) => plainToClass(CorpAPWorkQueueDetailResultDto, plain)));
    }

    approveWorkQueueAction(params: CorpAPWorkQueueEmailActionParameterDto): Observable<any> {
        const url = `${URLConstants.ccWorkQueueEmailActionsUrl}/approve`;
        return this.httpClient.put(url, classToPlain(params));
    }

    denyWorkQueueAction(params: CorpAPWorkQueueEmailActionDenyParameterDto): Observable<any> {
        const url = `${URLConstants.ccWorkQueueEmailActionsUrl}/deny`;
        return this.httpClient.put(url, classToPlain(params));
    }
}
